/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Mobi_EpubsInputs */

const en_mobile_benefits_mobi_epubs = /** @type {(inputs: Mobile_Benefits_Mobi_EpubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOBI & EPUBs`)
};

const es_mobile_benefits_mobi_epubs = /** @type {(inputs: Mobile_Benefits_Mobi_EpubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOBI & EPUBs`)
};

/**
* | output |
* | --- |
* | "MOBI & EPUBs" |
*
* @param {Mobile_Benefits_Mobi_EpubsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_mobi_epubs = /** @type {((inputs?: Mobile_Benefits_Mobi_EpubsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Mobi_EpubsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_mobi_epubs(inputs)
	return en_mobile_benefits_mobi_epubs(inputs)
});